import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Card } from '../../components/ui/card';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(formData.username, formData.password);
    
    if (result.success) {
      toast({
        title: 'Basarili!',
        description: 'Admin paneline hosgeldiniz.',
      });
      navigate('/admin/dashboard');
    } else {
      toast({
        title: 'Hata!',
        description: result.error || 'Giris basarisiz. Lutfen bilgilerinizi kontrol edin.',
        variant: 'destructive'
      });
    }
    
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-[#F9F6F1] flex items-center justify-center px-4">
      <Card className="w-full max-w-md p-8 bg-white border-2 border-[#E8DCC8]">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center space-x-2 mb-4">
            <BookOpen className="h-10 w-10 text-[#8B7355]" />
            <span className="text-2xl font-bold text-[#5C4033]">Kuran-i Kerim</span>
          </div>
          <h1 className="text-xl font-semibold text-[#5C4033]">Admin Paneli</h1>
          <p className="text-sm text-[#8B7355] mt-2">Lutfen giris yapiniz</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="text-sm font-medium text-[#5C4033]" htmlFor="username">
              Kullanici Adi
            </label>
            <Input
              id="username"
              name="username"
              type="text"
              placeholder="admin"
              value={formData.username}
              onChange={handleChange}
              required
              className="bg-[#F9F6F1] border-[#D5C4A1] text-[#5C4033]"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-[#5C4033]" htmlFor="password">
              Sifre
            </label>
            <Input
              id="password"
              name="password"
              type="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              required
              className="bg-[#F9F6F1] border-[#D5C4A1] text-[#5C4033]"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#8B7355] hover:bg-[#6B5744] text-white"
          >
            {loading ? 'Giris yapiliyor...' : 'Giris Yap'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default AdminLogin;